import { Card } from "@/components/ui/card.tsx"
import { classes } from "@/utils"
import { CardBody } from "@/deduction_table/summary_cards.tsx"
import { ActiveFilterIcon } from "@/global_filter"

export interface FilterCardProps {
  title: string
  count: number
  active: boolean
  onClick: () => void
  className?: string
  color?: string
}

export function FilterCard({ title, count, active, onClick, className, color }: FilterCardProps) {
  return (
    <Card
      className={classes(
        "cursor-pointer transition-all duration-200 hover:shadow-md hover:border-blue-300",
        active ? "border-blue-400 shadow-md" : "hover:border-blue-300",
        className || "w-36"
      )}
      onClick={onClick}>
      <CardBody
        value={count}
        // @ts-ignore
        title={
          <div className="flex items-center">
            {title}
            {active && <ActiveFilterIcon />}
          </div>
        }
        color={color}
      />
    </Card>
  )
}
